module.exports = __webpack_public_path__ + "img/3.d712a663.svg";